package com.example.ramsembedded.pages

import androidx.compose.runtime.Composable
import com.example.ramsembedded.components.layouts.PageLayout
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Page
@Composable
fun CoursesPage() {
    PageLayout("Courses"){
        PageContent()
    }
}

@Composable
fun PageContent() {
    Div(
        attrs = {
            style {
                padding(20.px)
                fontFamily("Arial", "sans-serif")
            }
        }
    ) {
        HeaderSection()
        CourseListSection()
        ContactSectionCourses()
    }
}

@Composable
fun HeaderSection() {
    Div(
        attrs = {
            style {
                textAlign("center")
                padding(16.px)
            }
        }
    ) {
        H1 { Text("Automotive Training in Bangalore") }
        P { Text("Expert-led courses to enhance your skills in the automotive industry.") }
    }
}

@Composable
fun CourseListSection() {
    Div(
        attrs = {
            style {
                padding(20.px)
            }
        }
    ) {
        H2 { Text("Available Courses") }
        Ul {
            listOf(
                "Embedded C, Data Structures",
                "Linux , RTOS",
                "C, C++, STL",
                "Interview Guidance & Mock Experience"
            ).forEach { course ->
                Li {
                    Text(course)
                }
            }
        }
    }
}

@Composable
fun ContactSectionCourses() {
    Div(
        attrs = {
            style {
                padding(20.px)
                textAlign("center")
                backgroundColor(Color.lightgray)
            }
        }
    ) {
        H2 { Text("Contact Us") }
        P { Text("For inquiries, email us.") }
    }
}
